import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _getOrderSettingsRequest = {};
var _getOrderSettingsResponse = {};
var _listOrderSettingsRequest = {};
var _listOrderSettingsResponse = {};
var _updateOrderSettingsRequest = { mask: 'google.protobuf.FieldMask' };
var _updateOrderSettingsResponse = {};
function resolveComWixpressRestaurantsOrdersettingsV3OrderSettingsApiUrl(opts) {
    var domainToMappings = {
        'www.wixapis.com': [
            {
                srcPath: '/restaurants/v3/order-settings',
                destPath: '/v3/order-settings',
            },
        ],
        _: [
            {
                srcPath: '/_api/order-settings',
                destPath: '/v3/order-settings',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/order-settings',
                destPath: '/v3/order-settings',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/order-settings',
                destPath: '/v3/order-settings',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/restaurants/v3/order-settings',
                destPath: '/v3/order-settings',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Get a OrderSettings by id */
export function getOrderSettings(payload) {
    var _a = serializer(_getOrderSettingsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getOrderSettingsResponse, {}).fromJSON;
    function __getOrderSettings(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.ordersettings.v3.order_settings',
            method: 'GET',
            methodFqn: 'com.wixpress.restaurants.ordersettings.v3.OrderSettingsApi.GetOrderSettings',
            url: resolveComWixpressRestaurantsOrdersettingsV3OrderSettingsApiUrl({
                protoPath: '/v3/order-settings/{orderSettingsId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getOrderSettings.fromReq = fromReq;
    __getOrderSettings.__isAmbassador = true;
    return __getOrderSettings;
}
/** Update a OrderSettings, supports partial update */
export function updateOrderSettings(payload) {
    var _a = serializer(_updateOrderSettingsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateOrderSettingsResponse, {}).fromJSON;
    function __updateOrderSettings(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.ordersettings.v3.order_settings',
            method: 'PATCH',
            methodFqn: 'com.wixpress.restaurants.ordersettings.v3.OrderSettingsApi.UpdateOrderSettings',
            url: resolveComWixpressRestaurantsOrdersettingsV3OrderSettingsApiUrl({
                protoPath: '/v3/order-settings/{orderSettings.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateOrderSettings.fromReq = fromReq;
    __updateOrderSettings.__isAmbassador = true;
    return __updateOrderSettings;
}
/** List Order settings */
export function listOrderSettings(payload) {
    var _a = serializer(_listOrderSettingsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listOrderSettingsResponse, {}).fromJSON;
    function __listOrderSettings(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.ordersettings.v3.order_settings',
            method: 'GET',
            methodFqn: 'com.wixpress.restaurants.ordersettings.v3.OrderSettingsApi.ListOrderSettings',
            url: resolveComWixpressRestaurantsOrdersettingsV3OrderSettingsApiUrl({
                protoPath: '/v3/order-settings',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listOrderSettings.fromReq = fromReq;
    __listOrderSettings.__isAmbassador = true;
    return __listOrderSettings;
}
//# sourceMappingURL=http.impl.js.map